import React from 'react'
import styles from './Chart.module.css'
import { Bar, Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    Title

} from "chart.js";
import { Box } from '@mui/material';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);
ChartJS.register(
    LineElement,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    Title
);

export default function StackedBarChart({ type, inform }) {

    let dataChartTotal = []
    let dataChartTotal2 = []
    let dataChartTotal3 = []
    let status_chart = []
    let idChart = ''
    let total = []

    const labelShow = () => {
        if (type === 'register') {
            let label = []
            { inform.map(i => (label.push(i['department_name_short']))) }
            return label
        } else if (type === 'score') {
            let label = []
            { inform.map(i => (label.push(i['e_learning_name']))) }
            return label
        }
    }

    switch (type) {
        case "register":
            idChart = 'register'
            status_chart.push('จบหลักสูตรแล้ว', 'อยู่ระหว่างเรียน', 'ลงทะเบียนเรียน')
            { inform.map(i => (dataChartTotal.push(i['progress_total']))) }
            { inform.map(i => (dataChartTotal2.push(i['register_total']))) }
            { inform.map(i => (dataChartTotal3.push(i['success_total']))) }
            { inform.map(i => (total.push(i['total']))) }
            break;

        case "score":
            idChart = 'score'
            status_chart.push('ก่อนเรียน (ถ้ามี)', 'หลังเรียน')
            { inform.map(i => (dataChartTotal.push(i['score_avg_pre_test']))) }
            { inform.map(i => (dataChartTotal2.push(i['score_avg_post_test']))) }
            break;

        default:
    }

    const data = {
        labels: labelShow(),
        datasets: [
            {
                label: status_chart[0],
                backgroundColor: "#98e7c5",
                data: dataChartTotal,
                maxBarThickness: 50
            },
            {
                label: status_chart[1],
                backgroundColor: "#F8C687",
                data: dataChartTotal2,
                maxBarThickness: 50
            },
            {
                label: status_chart[2],
                backgroundColor: "#87e7f8",
                data: dataChartTotal3,
                maxBarThickness: 50
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            datalabels: {
                display: false
            },
            legend: {
                display: false
            },
            tooltip: {
                bodyFont: {
                    family: 'IBM Plex Sans Thai', // เปลี่ยนตรงนี้เป็น font family ที่ต้องการ
                },
                titleFont: {
                    family: 'IBM Plex Sans Thai',
                },
                callbacks: {
                    label: ((context) => {
                        // let id = type
                        const dataIndexValue = context.formattedValue
                        const dataIndex = context.dataIndex
                        const percent = (dataIndexValue / total[dataIndex]) * 100
                        const dataPercent = dataIndexValue + ' คน ' + '(' + percent.toFixed(2) + '%)'
                        return dataPercent
                    }),
                }
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: 12
                    }
                }
            },
            y: {
                stacked: true,
                beginAtZero: true,
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: 12
                    }
                }
            },
        },
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Bar data={data} options={options} />
            <Box className={styles.contentLegend2}>
                {status_chart.map((item, index) => (
                    <Box key={`${idChart}_${index}`} className={styles.Legend}>
                        <Box className={styles.dotLegend} style={index == 0 ? { backgroundColor: '#98e7c5' } : index == 1 ? { backgroundColor: '#F8C687' } : { backgroundColor: '#87e7f8' }}></Box>
                        <p>{item}</p>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export function StackedLineChartProject({ inform, color, type, date, summary, total }) {

    const colors = color?.[type] || null
    const colorList = Object.keys(color?.[type] || {})

    // const list = inform?.[type]
    const initItem = {
        record_date: date,
        summary: summary?.[type]
    }

    const list = [initItem].concat(inform?.[type]);

    const labels = list?.map((g) => g?.record_date ?? '');
    const datasets = colorList.map((item) => ({
        label: item,
        rawDatasets: list.map((g) => g?.summary?.[item] ?? 0),
        data: list.map((g) => {
            const value = g?.summary?.[item] ?? 0;
            return total ? (value / total) * 100 : 0
        }),
        borderColor: colors[item],
        backgroundColor: colors[item],
        // pointBackgroundColor: '#fff'
    }));

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const data = {
        labels: labels.map(convertDate),
        datasets: datasets
    };

    const options = {
        responsive: true,
        plugins: {
            datalabels: {
                display: false
            },
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: '14'
                    },
                },
            },
            title: {
                display: true,
                text: 'กราฟแสดงอัตราการเปลี่ยนแปลงของข้อมูล',
                font: {
                    family: 'IBM Plex Sans Thai',
                    size: '14'
                },
            },
            tooltip: {
                bodyFont: {
                    family: 'IBM Plex Sans Thai', // เปลี่ยนตรงนี้เป็น font family ที่ต้องการ
                },
                titleFont: {
                    family: 'IBM Plex Sans Thai',
                },
                callbacks: {
                    label: function (context) {
                        const dataset = context.dataset;
                        const index = context.dataIndex;
                        const label = dataset.label || '';

                        const realValue = dataset.rawDatasets?.[index] ?? 0;
                        const percent = ((realValue / total) * 100).toFixed(1);

                        return `${label}: ${realValue} คน (${percent}%)`;
                    }
                }
            },
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: 12
                    }
                }
            },
            y: {
                beginAtZero: true,
                max: 100,
                title: {
                    display: true,
                    text: 'ร้อยละ',
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: '14'
                    },
                },
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai'
                    },
                    stepSize: 10,
                    callback: value => `${value}`
                },
                suggestedMax: total
            },
        },
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Line data={data} options={options} />
        </Box>
    )
}

export function StackedBarChartProject({ inform, color, type, date, summary, total }) {

    const colors = color?.[type] || null
    const colorList = Object.keys(color?.[type] || {})

    const initItem = {
        record_date: date,
        summary: summary?.[type]
    }

    const list = [initItem].concat(inform?.[type]);

    const labels = list?.map((g) => g?.record_date ?? '');
    const datasets = colorList.map((item) => ({
        label: item,
        // data: list.map((g) => g?.summary?.[item] ?? 0),
        rawDatasets: list.map((g) => g?.summary?.[item] ?? 0),
        data: list.map((g) => {
            const value = g?.summary?.[item] ?? 0;
            return total ? (value / total) * 100 : 0
        }),
        backgroundColor: colors[item],
        barThickness: 40,
    }));

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const data = {
        labels: labels.map(convertDate),
        datasets: datasets
    };

    const options = {
        responsive: true,
        plugins: {
            datalabels: {
                display: true,
                color: '#000',
                font: {
                    family: 'IBM Plex Sans Thai',
                    size: 12
                },
                formatter: (value, context) => {
                    const real = context.dataset.rawDatasets?.[context.dataIndex] ?? 0;
                    const percent = ((real / total) * 100).toFixed(1);
                    return `${real} คน  (${percent}%)`;
                },
            },
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: '14'
                    },
                },
            },
            title: {
                display: false
            },
            tooltip: {
                bodyFont: {
                    family: 'IBM Plex Sans Thai', // เปลี่ยนตรงนี้เป็น font family ที่ต้องการ
                },
                titleFont: {
                    family: 'IBM Plex Sans Thai',
                },
                mode: 'index',
                intersect: false,
                backgroundColor: 'white',
                titleColor: 'black',
                bodyColor: 'black',
                borderWidth: 1,
                borderColor: 'rgb(244, 244, 244)',
                callbacks: {
                    label: function (context) {
                        const realValue = context.dataset.rawDatasets?.[context.dataIndex] ?? 0;
                        const total = context.chart.data.datasets
                            .map(dataset => dataset.data[context.dataIndex])
                            .reduce((sum, val) => sum + val, 0);
                        const percentage = ((realValue / total) * 100).toFixed(2);
                        return `${context.dataset.label}: ${realValue} คน (${percentage}%)`;
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: 12
                    }
                }
            },
            y: {
                stacked: true,
                beginAtZero: true,
                max: 100,
                title: {
                    display: true,
                    text: 'ร้อยละ',
                    font: {
                        family: 'IBM Plex Sans Thai',
                        size: '14'
                    },
                },
                ticks: {
                    font: {
                        family: 'IBM Plex Sans Thai'
                    },
                    stepSize: 10,
                    callback: function (value) {
                        return `${value}`;
                    }
                },
                suggestedMax: total
            },
        },
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Bar data={data} options={options} />
        </Box>
    )
}
